<div mat-dialog-title class="ed-header">
    <div class="ed-header-main">
        <div class="ed-eyebrow">Edit Master <span class="ed-eyebrow-dot"></span> ID {{ data.id }}</div>
        <div class="ed-title">
            {{ data['text'] }}
            <i (click)="getWinOlsToClipboard()" class="bi bi-clipboard ed-copy" ngbTooltip="Copy"></i>
        </div>
    </div>
    <button type="button" class="ed-close" (click)="canceledOption()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
    </button>
</div>

<div class="ed-tabs">
    <button type="button" class="ed-tab" [class.active]="activeTab() === 'build'" (click)="activeTab.set('build')">
        ECU Build
    </button>
    <button type="button" class="ed-tab" [class.active]="activeTab() === 'details'" (click)="activeTab.set('details')">
        Details
    </button>
</div>

<mat-dialog-content class="ed-content" [formGroup]="updateMasterItemForm" (keydown.enter)="confirmedOption()">
    <div class="ed-col ed-col-table" [class.ed-hide-mobile]="activeTab() !== 'build'">
        <div class="ed-col-head">
            <div class="ed-step">
                <span class="ed-step-num">Step 1</span>
                <span class="ed-step-label">Select ECU Build — single click applies and auto-fills ECU Producer</span>
            </div>
            <div class="ed-step-title">ECU Build &amp; Producer</div>
        </div>
        <div class="ed-table-wrap">
            <app-ecu-build-names-table [ecuBuild]="ecuBuild"
                                       [searchQueryCorrectEcuNamesInput]="ecuBuildSearchQuery"
                                       (correctEcuBuildName)="getCorrectEcuName($event)"></app-ecu-build-names-table>
        </div>
    </div>

    <div class="ed-col ed-col-form" [class.ed-hide-mobile]="activeTab() !== 'details'">
        <div class="ed-col-head">
            <div class="ed-step">
                <span class="ed-step-num">Step 2</span>
                <span class="ed-step-label">Review ini file details</span>
            </div>
            <div class="ed-step-title">Master properties</div>
        </div>

        <div class="ed-grid">
            <div class="ed-field ed-field-accent">
                <div class="ed-field-label">
                    <span>Ecu Build <span class="ed-req">*</span></span>
                    <span class="ed-badge">From table</span>
                    <button type="button" (click)="addNewEcu()" class="ed-add-btn"><i class="bi bi-plus-lg"></i></button>
                </div>
                <input class="ed-field-input" formControlName="ecuBuild" id="firstDialogElement"/>
                <div class="ed-field-error" *ngIf="updateMasterItemForm.get('ecuBuild').hasError('valid')">Please enter a valid Ecu Build.</div>
                <div class="ed-field-error" *ngIf="updateMasterItemForm.get('ecuBuild').hasError('required')">Ecu Build is required.</div>
            </div>

            <div class="ed-field ed-field-accent">
                <div class="ed-field-label">
                    <span>Ecu Producer <span class="ed-req">*</span></span>
                    <span class="ed-badge">Auto</span>
                    <button type="button" (click)="addNewEcuProducer()" class="ed-add-btn"><i class="bi bi-plus-lg"></i></button>
                </div>
                <input class="ed-field-input" formControlName="ecuProducer" id="secondDialogElement" [matAutocomplete]="ecuProducerAuto"/>
                <mat-autocomplete #ecuProducerAuto="matAutocomplete" class="ed-autocomplete-panel">
                    <mat-option *ngFor="let producer of ecuProducerOptions()" [value]="producer">{{ producer }}</mat-option>
                </mat-autocomplete>
                <div class="ed-field-error" *ngIf="updateMasterItemForm.get('ecuProducer').hasError('valid')">Please enter a valid Ecu Producer.</div>
                <div class="ed-field-error" *ngIf="updateMasterItemForm.get('ecuProducer').hasError('required')">Ecu Producer is required.</div>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Type <span class="ed-req">*</span></label>
                <input class="ed-field-input" formControlName="engineType"/>
                <div class="ed-field-error" *ngIf="updateMasterItemForm.get('engineType').hasError('required')">Engine Type is required.</div>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Ecu Use</label>
                <input class="ed-field-input" formControlName="ecuUse"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">ID</label>
                <input class="ed-field-input" [value]="data.id" readonly/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Uploaded By</label>
                <input class="ed-field-input" formControlName="uploadedBy"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Ecu ProdNr</label>
                <input class="ed-field-input" formControlName="ecuProdNr"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Ecu Software Version</label>
                <input class="ed-field-input" formControlName="ecuSoftwareVersion"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Sw Version Version</label>
                <input class="ed-field-input" formControlName="ecuSoftwareVersionVersion"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Ecu Stg Nr</label>
                <input class="ed-field-input" formControlName="ecuStgNr"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Ecu Processor</label>
                <input class="ed-field-input" formControlName="ecuProcessor"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Producer</label>
                <input class="ed-field-input" formControlName="vehicleProducer" [matAutocomplete]="vehicleProducerAuto"/>
                <mat-autocomplete #vehicleProducerAuto="matAutocomplete" class="ed-autocomplete-panel">
                    <mat-option *ngFor="let producer of vehicleProducerOptions()" [value]="producer">{{ producer }}</mat-option>
                </mat-autocomplete>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Type</label>
                <input class="ed-field-input" formControlName="vehicleType" [matAutocomplete]="vehicleTypeAuto"/>
                <mat-autocomplete #vehicleTypeAuto="matAutocomplete" class="ed-autocomplete-panel">
                    <mat-option *ngFor="let type of vehicleTypeOptions()" [value]="type">{{ type }}</mat-option>
                </mat-autocomplete>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Series</label>
                <input class="ed-field-input" formControlName="vehicleSeries"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Model</label>
                <input class="ed-field-input" formControlName="vehicleModel"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Model Year</label>
                <input class="ed-field-input" formControlName="vehicleModelYear"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Build</label>
                <input class="ed-field-input" formControlName="vehicleBuild"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Vehicle Characteristic</label>
                <input class="ed-field-input" formControlName="vehicleCharacteristic"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Name</label>
                <input class="ed-field-input" formControlName="engineName"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Producer</label>
                <input class="ed-field-input" formControlName="engineProducer"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Displacement</label>
                <input class="ed-field-input" formControlName="engineDisplacement"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine MaxTorque</label>
                <input class="ed-field-input" formControlName="engineMaxTorque"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Emission</label>
                <input class="ed-field-input" formControlName="engineEmission"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Gear</label>
                <input class="ed-field-input" formControlName="engineGear"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Engine Transmission</label>
                <input class="ed-field-input" formControlName="engineTransmission"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Output Ps</label>
                <input class="ed-field-input" formControlName="outputPs"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Output KW</label>
                <input class="ed-field-input" formControlName="outputKw"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Reading Hardware</label>
                <input class="ed-field-input" formControlName="readingHardware"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Additional Info</label>
                <input class="ed-field-input" formControlName="additionalInfo"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Project Created By</label>
                <input class="ed-field-input" formControlName="projectCreatedBy"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Project Changed By</label>
                <input class="ed-field-input" formControlName="projectChangedBy"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Project Comment</label>
                <input class="ed-field-input" formControlName="projectComment"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Version Comment</label>
                <input class="ed-field-input" formControlName="versionComment"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Software Number</label>
                <input class="ed-field-input" formControlName="softwareNumber"/>
            </div>

            <div class="ed-field">
                <label class="ed-field-label">Project Type</label>
                <input class="ed-field-input" formControlName="projectType"/>
            </div>
        </div>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="ed-footer">
    <div class="ed-status" [class.ok]="requiredFieldsFilled">
        <span class="ed-status-dot"></span>
        {{ requiredFieldsFilled ? 'All required fields filled' : 'Required fields missing' }}
    </div>
    <div class="ed-actions">
        <button type="button" class="ed-btn ed-btn-ghost" (click)="canceledOption()">Cancel</button>
        <button type="button" class="ed-btn ed-btn-primary" [disabled]="updateMasterItemForm.invalid"
                (click)="confirmedOption()"><i class="bi bi-check-lg"></i>Save changes
        </button>
    </div>
</div>
